export default __webpack_public_path__ + "static/media/UR_Lucifer.1bbd77c2.png";